import { render, staticRenderFns } from "./paymentsuccess.vue?vue&type=template&id=32d85ed4&scoped=true"
import script from "./paymentsuccess.vue?vue&type=script&lang=js"
export * from "./paymentsuccess.vue?vue&type=script&lang=js"
import style0 from "./paymentsuccess.vue?vue&type=style&index=0&id=32d85ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d85ed4",
  null
  
)

export default component.exports